if ($('.event-table__wrapper')[0]) {
	const wrapper = document.querySelector('.event-table__table-wrap');
	const bar = document.querySelector('.event-table__bar');
	const thumb = document.querySelector('.event-table__thumb');

	let isDragging = false;
	let startX = 0;
	let startLeft = 0;

	function updateThumb() {
		if (!wrapper || !bar || !thumb) return;

		const visible = wrapper.clientWidth;
		const total = wrapper.scrollWidth;

		if (total <= visible) {
			bar.style.display = 'none';
			return;
		} else {
			bar.style.display = 'block';
		}

		const maxScroll = total - visible;

		const thumbWidthPx = (visible / total) * bar.clientWidth;
		thumb.style.width = `${thumbWidthPx}px`;

		const maxThumbLeft = bar.clientWidth - thumbWidthPx;
		const leftPx = (wrapper.scrollLeft / maxScroll) * maxThumbLeft;

		thumb.style.left = `${Math.max(0, leftPx)}px`;
	}

	function onDragStart(e) {
		isDragging = true;
		startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;

		startLeft = thumb.offsetLeft;
		document.body.classList.add('is-dragging');
	}

	function onDragMove(e) {
		if (!isDragging) return;

		const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;

		const deltaX = clientX - startX;

		const maxThumbLeft = bar.clientWidth - thumb.clientWidth;
		const newLeft = Math.min(maxThumbLeft, Math.max(0, startLeft + deltaX));

		thumb.style.left = `${newLeft}px`;

		const scrollRatio = newLeft / maxThumbLeft;
		const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

		wrapper.scrollLeft = scrollRatio * maxScroll;
	}

	function onDragEnd() {
		isDragging = false;
		document.body.classList.remove('is-dragging');
	}

	thumb.addEventListener('mousedown', onDragStart);
	thumb.addEventListener('touchstart', onDragStart, { passive: true });

	document.addEventListener('mousemove', onDragMove);
	document.addEventListener('touchmove', onDragMove, { passive: false });

	document.addEventListener('mouseup', onDragEnd);
	document.addEventListener('touchend', onDragEnd);

	wrapper.addEventListener('scroll', updateThumb, { passive: true });
	window.addEventListener('resize', updateThumb);

	updateThumb();
}
